import { GraderWidget } from "@/components/GraderWidget";
import { PageHead } from "@/components/Layout";

export default function GraderPage() {
  return (
    <div data-testid="grader-page">
      <PageHead eyebrow="Free tool" title="Listing Grader" sub="A score out of 100 on clarity, appeal, search keywords, completeness and trust, plus the 3 fixes that matter most." />
      <section className="max-w-4xl px-6 lg:px-10 mx-auto lg:mx-0 lg:ml-[max(1.5rem,calc((100vw-80rem)/2+2.5rem))] pb-24">
        <GraderWidget />
      </section>
    </div>
  );
}
